export const GWORKSPACE_JSON_UPLOAD_KEY = "service_account_json_upload";
export const GWORKSPACE_ADMIN_EMAIL_KEY = "admin_email";

export function parseGWorkspaceServiceAccountJson(raw: string): Record<string, unknown> {
  const parsed = JSON.parse(raw);
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) {
    throw new Error("Service account JSON must be a JSON object.");
  }
  return parsed as Record<string, unknown>;
}

export function buildGWorkspaceConfig(values: Record<string, string>): Record<string, unknown> {
  const rawJson = values[GWORKSPACE_JSON_UPLOAD_KEY];
  if (!rawJson?.trim()) {
    throw new Error("Service Account JSON is required.");
  }

  return {
    service_account_json: parseGWorkspaceServiceAccountJson(rawJson),
    admin_email: values[GWORKSPACE_ADMIN_EMAIL_KEY] || "",
  };
}

export function validateGWorkspaceForm(values: Record<string, string>): Record<string, string> {
  const errors: Record<string, string> = {};

  if (!values[GWORKSPACE_JSON_UPLOAD_KEY]?.trim()) {
    errors[GWORKSPACE_JSON_UPLOAD_KEY] = "Service Account JSON is required.";
  }

  if (!values[GWORKSPACE_ADMIN_EMAIL_KEY]?.trim()) {
    errors[GWORKSPACE_ADMIN_EMAIL_KEY] = "Super Admin Email is required.";
  }

  return errors;
}

export function applyGWorkspaceServiceAccountUpload(
  rawJson: string,
  fileName: string
): { values: Record<string, string>; fileNames: Record<string, string> } {
  parseGWorkspaceServiceAccountJson(rawJson);

  return {
    values: {
      [GWORKSPACE_JSON_UPLOAD_KEY]: rawJson,
    },
    fileNames: {
      [GWORKSPACE_JSON_UPLOAD_KEY]: fileName,
    },
  };
}
